import styled from 'styled-components'

export const Popper = styled.div`
  background: var(--surface-primary);
  border-radius: var(--border-radius-md);
  border: 1px solid var(--border);
  padding: 3px 5px;
  box-shadow: rgba(255, 255, 255, 0.1) 0 0 0 1px, hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  // transition-duration: 400ms;
  // transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  // transition-property: opacity;
  /** Must show above SlideoutDialog */
  z-index: 101;
`
